import React, {useEffect} from 'react';
import {createStructuredSelector} from 'reselect';
import {useDispatch, useSelector} from 'react-redux';
import {toggleQuoteCallMeBack} from '@om/redux/actions/easiplusFuneralPlan/callMeBack';
import {
    clearConfirmDeleteMember,
    deleteCover,
    sendQuoteCreateQuote,
} from '@om/redux/actions/easiplusFuneralPlan/quote';
import {
    getQuoteReferenceData,
    getApplicationReferenceData,
} from '@om/redux/actions/easiplusFuneralPlan/referenceData';
import {
    getCreateQuoteError,
    getRemoveMemberMessage,
} from '@om/redux/selectors/easiplusFuneralPlan/quote';
import {
    OmApplicationPopupModal,
    OmIcon,
} from '@om/component-library-react';
import OmButton from '../../../../components/forms/OmButton';
import DirectFamilyDrawer from './DirectFamilyDrawer';
import ParentsAndInLawsDrawer from './ParentsAndInLawsDrawer';
import ExtendedFamilyDrawer from './ExtendedFamilyDrawer';
import LivesCoveredQuoteSideDrawer from './LivesCoveredQuoteDrawer';
import CallMeBack from './CallMeBack';

const QuoteModals = () => {
    const dispatch = useDispatch();
    const {
        removeMemberMessage,
        createQuoteError,
    } = useSelector(
        createStructuredSelector({
            removeMemberMessage: getRemoveMemberMessage,
            createQuoteError: getCreateQuoteError,
        })
    );

    useEffect(() => {
        dispatch(getApplicationReferenceData());
        dispatch(getQuoteReferenceData());
    }, [dispatch]);

    const confirmDelete = () => {
        dispatch(deleteCover());
        dispatch(clearConfirmDeleteMember());
    };

    return (
        <div>
            <LivesCoveredQuoteSideDrawer />
            <DirectFamilyDrawer />
            <ParentsAndInLawsDrawer />
            <ExtendedFamilyDrawer />
            <CallMeBack />

            <OmApplicationPopupModal dismissible name="removeModal">
                <div slot="content">
                    <OmIcon
                        imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/bltc34f1c6e32fb7291/5ec3d2d2a4bead4101d1941f/TrashSVG.svg"
                    />
                    <p>{removeMemberMessage}</p>
                </div>
                <div slot="button">
                    <OmButton
                        type="primary"
                        size="small"
                        text="YES, REMOVE"
                        onClick={() => confirmDelete()}
                    />
                </div>
            </OmApplicationPopupModal>

            <OmApplicationPopupModal
                dismissible
                name="maxAdded"
            >
                <div slot="content">
                    <p>You are only allowed to cover up to 15 members.</p>
                </div>
                <div slot="button">
                    <OmButton
                        type="primary"
                        size="small"
                        text="OKAY, THANKS"
                        onClick={() => {}}
                    />
                </div>
            </OmApplicationPopupModal>

            <OmApplicationPopupModal
                name="errorModal"
                exitable="false"
                open={createQuoteError}
            >
                <div slot="content">
                    <OmIcon
                        imageUrl="https://eu-images.contentstack.com/v3/assets/blt0554f48052bb4620/blt7379af7d0a25dd73/5ee9f203557e3a516a2d9a29/desktop_monitor_smiley.svg"
                    />
                    <h4 className="medium">
                        Oops!<br />
                        Something went wrong.
                    </h4>
                </div>
                <div slot="button">
                    <OmButton
                        type="primary"
                        size="small"
                        text="Call me back"
                        onClick={() => dispatch(toggleQuoteCallMeBack())}
                    />
                    <OmButton
                        type="secondary"
                        size="small"
                        text="Try again"
                        onClick={() => dispatch(sendQuoteCreateQuote())}
                    />
                </div>
            </OmApplicationPopupModal>
        </div>
    );
};

export default QuoteModals;
